<form (ngSubmit)="onSubmit()" [formGroup]="modelPjTypeForm" style="margin-top: 20px">
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="15px">
      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <mat-label>Nom de la catégorie</mat-label>
        <input formControlName="name" matInput
               matTooltip="Catégorie des modèles de pièces jointes"
               placeholder='Financière, ...'
               type="text">
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <mat-label>Description de la catégorie</mat-label>
        <textarea formControlName="description" matInput
                  matTooltip="Description de la catégorie"
                  placeholder='Catégorie servant à regrouper les pj financières'></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="onNoClick()"
            mat-raised-button
            color="primary"
            type="button">
      Annuler
    </button>
    <button mat-raised-button
            cdkFocusInitial
            color="accent"
            type="submit"
            [disabled]="!modelPjTypeForm.valid">
      Sauvegarder
    </button>
  </mat-dialog-actions>
</form>
